<template>
  <div>
    <Head title="Users" />
    <h1 class="mb-8 text-3xl font-bold">{{ $t('sheets.title') }}</h1>
    <div class="flex items-center justify-between mb-6">
      <div class="mr-4 w-full max-w-md"></div>
      <Link class="btn-indigo" :href="route('sheets.create')">
        <span>{{ $t('sheets.sub_title_1') }}</span>
        <span class="hidden md:inline">&nbsp;{{ $t('sheets.sub_title_2') }}</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">{{ $t('sheets.table.name') }}</th>
          <th class="pb-4 pt-6 px-6">{{ $t('sheets.table.status') }}</th>
          <th class="pb-4 pt-6 px-6">{{ $t('sheets.table.update') }}</th>
          <th class="pb-4 pt-6 px-6" colspan="2"></th>
        </tr>
        <tr v-for="sheet in sheets" :key="sheet.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="route('sheets.edit', {sheet: sheet.id})" tabindex="-1">
              {{ sheet.name }}
            </Link>
          </td>
          <td class="border-t px-6">
            <toggle-input :model-value="sheet.is_active" :disabled="true"></toggle-input>
          </td>
          <td class="border-t px-6">
            <button type="button" class="px-4 py-1 text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm" @click="updateSheet(sheet.id)">
              Update Sheet
            </button>

            <button type="button" class="px-4 py-1 ml-4 text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm" @click="clearComments(sheet.id)">
              Clear Comments
            </button>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="route('sheets.edit', {sheet: sheet.id})" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="sheets.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">{{ $t('sheet.table.no_result') }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import ToggleInput from '@/Shared/ToggleInput'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Head,
    Link,
    ToggleInput,
    Icon,
  },
  layout: Layout,
  props: {
    sheets: Array,
  },
  methods: {
    updateSheet(sheetId) {
      if (confirm('Are you sure you want to update this sheet?')) {
        this.$inertia.visit(this.route('sheets.update.data', {sheet: sheetId}), {
          method: 'get',
        })
      }
    },
    clearComments(sheetId) {
      if (confirm('Are you sure you want to clear all comments for this sheet?')) {
        this.$inertia.visit(this.route('sheets.clear.comments', {sheet: sheetId}), {
          method: 'get',
        })
      }
    },
  },
}
</script>
